// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"L0-z"};